import React, { useContext, useEffect, useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Task } from '../../interfaces/Task';
import { Footer } from 'rsuite';

interface TaskCommentProps {
    show: boolean;
    onHide: () => void;
    onSubmit: (newUser: Task, oldUser?: Task) => void;
    task: Task;
}

const TaskComment = ({ show, onHide, onSubmit, task }: TaskCommentProps) => {
    const [comment, setComment] = useState(task.comment);
    const [enterClicked, setEnterClicked] = useState(false);
    const inputRef = useRef<HTMLTextAreaElement | null>(null);
    const handleSaveClick = () => {
        if (comment) {
            onSubmit({ ...task, comment }, task);
        } else {
            onHide();
            return;
        }
    };

    useEffect(() => {
        if (enterClicked) {
            if (!comment) {
                onHide();
                // setEnterClicked(false);
                return;
            }
        }
    }, [enterClicked]);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }

        if (task) {
            setComment(task.comment);
        }
        console.log('task', task);
    }, [task]);

    useEffect(() => {
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 100);
    }, [inputRef]);

    const onChange = (event: any) => {
        const name = event.target.name;
        let value = event.target.value;
        setComment(value);
    };

    useEffect(() => {
        const handleKeyPress = (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                // event.preventDefault();
                // event.stopPropagation();
                // handleSaveClick();
                setEnterClicked(true);
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    return (
        <>
            <Modal show={show} onHide={onHide} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header className="bg-light" onHide={onHide} closeButton>
                    <Modal.Title className="m-0">{task.text}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    <div className="task-edit-form">
                        <div className="mb-3">
                            <label className="form-label">Why are you closing this task?</label>
                            <textarea
                                ref={inputRef}
                                // label="Why are you closing this task?"
                                className="form-control"
                                name="comment"
                                defaultValue={comment}
                                placeholder="enter reason here"
                                onChange={onChange}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Footer>
                    <div className="text-end p-2 pe-3">
                        <Button variant="success" onClick={handleSaveClick} className="waves-effect waves-light ">
                            Save
                        </Button>
                    </div>
                </Footer>
            </Modal>
        </>
    );
};
export default TaskComment;
